// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"8ab1ff07756c2060c7e0","522":"4d8523896857eb4eeff9"}[chunkId] + ".js";
};